<template>
  <div class="mb-2" v-if="slots.length">
    <div class="visit-time-slot-grid-label">{{ $t(label) }}</div>
    <div class="d-flex flex-wrap gap-2">
      <div v-for="(s, sind) in slots"
           :key="`slot-${label}-${sind}`"
           class="visit-time-slot pointer"
           :class="{ active: isSelected(s), disabled: readonly }"
           @click="select(s)">
        {{ s.start }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    required: true
  },
  slots: {
    type: Array,
    default: () => []
  },
  value: {
    type: String,
    default: null
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const isSelected = (s) => props.value && s.start === props.value

const select = (s) => {
  if(props.readonly) return
  emit('select', s)
}
</script>

<style scoped lang="scss">
.visit-time-slot-grid-label {
  color: $gray-text2;
  font-size: 13px;
  margin-bottom: 8px;
}
.visit-time-slot {
  border-radius: 8px;
  background: $gray-btn;
  padding: 6px 14px;
  font-size: 14px;
  &.active {
    background: $blue-color;
    color: #fff;
  }
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
@media screen and (max-width: 768px) {
  .visit-time-slot {
    padding: 4px 10px;
    font-size: 12px;
  }
}
</style>
